import React from 'react'

import { useFreeSpinsBonusesStore } from '@stores'
import { BSModalButton } from '@components'
import { useTranslation } from '@amusnet/translations/react'
import { FreespinBonusEndModalButtonClickedMessage, BonusSystemState, GameUIMessageType } from 'game-ui-types'

const FSEndButtons: React.FC = () => {
    const setBonusSystemState = useFreeSpinsBonusesStore((state) => state.setBonusSystemState)
    const hasActiveBonusesLeft = useFreeSpinsBonusesStore((state) => state.hasActiveBonusesLeft)
    const setShowRemainingSpinsBanner = useFreeSpinsBonusesStore((state) => state.setShowRemainingSpinsBanner)
    const setTotalWin = useFreeSpinsBonusesStore((state) => state.setTotalWin)

    const { t } = useTranslation()

    const okButtonHandler = () => {
        setTotalWin('0')
        setShowRemainingSpinsBanner(hasActiveBonusesLeft)
        setBonusSystemState(hasActiveBonusesLeft ? BonusSystemState.IN_PLAY : BonusSystemState.INACTIVE)

        const bonusEndModalButtonClickedMessage: FreespinBonusEndModalButtonClickedMessage = {
            type: GameUIMessageType.FREESPIN_BONUS_END_MODAL_BUTTON_CLICKED,
        }

        window.uiBus.postMessage(bonusEndModalButtonClickedMessage)
    }

    return (
        <div className="flex flex-col items-center w-full py-[10px]">
            <BSModalButton id="freespin-bonus-ok" text={t('gameui.ok')} onClick={okButtonHandler} />
        </div>
    )
}

export default FSEndButtons
